module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-window",
    attrs: {
      "id": "news_window"
    },
    on: {
      "touchmove": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "container xsqcon"
  }, [_c('div', {
    staticClass: "prize-show"
  }, [_c('div', {
    staticClass: "prize-row"
  }, [_c('span', {
    staticClass: "prize-amount"
  }, [(!Number(_vm.newUserObj.data.discount)) ? [_c('span', [_vm._v("￥")]), _c('span', {
    staticClass: "coupon-value"
  }, [_vm._v(_vm._s(_vm._f("moneyFormat")(_vm.newUserObj.data.amount)))])] : [_c('span', [_vm._v(_vm._s(_vm.newUserObj.data.discount.replace(/^(\d+)\.0+$/, '$1')) + "折券")])]], 2), _vm._v(" "), _c('span', {
    staticClass: "prize-name"
  }, [(_vm.newUserObj.data.teacher_info && _vm.newUserObj.data.teacher_info.nickname) ? [_c('img', {
    staticClass: "prize-avatar",
    attrs: {
      "src": _vm.newUserObj.data.teacher_info.avatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "prize-teacher"
  }, [_vm._v(_vm._s(_vm.newUserObj.data.teacher_info.nickname))])] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "name-txt"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.newUserObj.data.name) + "\n\t\t\t\t\t\t\t")])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "prize-row"
  }, [_c('span', {
    staticClass: "coupon-tip"
  }, [_vm._v("满" + _vm._s(_vm._f("moneyFormat")(_vm.newUserObj.data.mininum)) + "可用")]), _vm._v(" "), _c('span', {
    staticClass: "prize-end"
  }, [_vm._v("有效期至:" + _vm._s(_vm.newUserObj.data.end_time_format))])])]), _vm._v(" "), _c('div', {
    staticClass: "guild-btn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.newsClickHandler(_vm.newUserObj.data)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t立即使用\n\t\t\t\t")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6370b9e6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6370b9e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!(webpack)-px-to-rem?{"basePx":75,"min":1}!./src/common/components/newUserPopLink.vue
// module id = 420
// module chunks = 32